import { EventLogResponseInterface, RequestInterface } from '@interface/logs/logs.interface';
import { BaseStoreInterface } from '@interface/store/base-store.interface';
import { BaseStoreStructure } from '@util/constants/store.constants';

export const initialLogsState: BaseStoreInterface<{
  requests: RequestInterface[];
  events: EventLogResponseInterface[];
}> = {
  ...BaseStoreStructure,
  data: {
    requests: [],
    events: [],
  },
};
